import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import PublicHeader from '../../components/PublicHeader';
import PublicFooter from '../../components/PublicFooter';
import StepArrowLine from '../../components/atoms/StepArrowLine';
import StepShopOnButton from '../../components/atoms/StepShopOnButton';
import StepMenuOnButton from '../../components/atoms/StepMenuOnButton';
import StepIdentityOnButton from '../../components/atoms/StepIdentityOnButton';
import StepIdentityConfirmOnButton from '../../components/atoms/StepIdentityConfirmOnButton';

const styles = {
  root: {
    backgroundColor: '#ffffff',
    flexGrow: 1,
    width: '100%'
  },
  mainPaper: {
    margin: '120px auto',
    maxWidth: '750px',
    border: '1px solid #1976d2'
  },
  paperHeader: {
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow:
      '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'
  },
  paperHeaderTitle: {
    color: '#ffffff'
  },
  paperContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  paperContentItem: {
    margin: '10px auto'
  },
  comment1: {
    fontSize: '1.0rem'
  },
  comment2: {
    fontSize: '0.65rem'
  },
  registerStep: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  registerStepItem: {
    display: 'flex',
    flexDirection: 'column'
  },
  registerStepItemWidth: {
    display: 'flex',
    flexDirection: 'column',
    width: '40px'
  },
  textRed: {
    color: '#f00'
  },
  textBold: {
    fontWeight: 'bold'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(({ classes, handleRedirect }) => {
  return (
    <div className={classes.root}>
      <PublicHeader />
      <Paper className={classes.mainPaper} elevation={1}>
        <Box bgcolor="primary.main" className={classes.paperHeader}>
          <Typography variant="h6" className={classes.paperHeaderTitle}>
            ごちめし開店情報登録画面
          </Typography>
        </Box>
        <div className={classes.paperContent}>
          <Typography
            className={classNames(
              classes.paperContentItem,
              classes.textRed,
              classes.textBold
            )}
          >
            ※スマートフォンの場合は横画面表示でご利用ください。
          </Typography>
          <div className={classes.paperContentItem}>
            <Typography
              align="center"
              component="p"
              className={classes.comment1}
            >
              以下の順番に従い、ごちめし開店処理を進めてください。
              <br />
              店舗やメニュー情報は開店処理の後からでも変更できます。
            </Typography>
            <Typography align="center" className={classes.comment2}>
              ※未入力・未完了のものは白く、登録・完了したものは中が塗られて表示されています。
              <br />
              本人情報登録がごちめし事務局にて承認されますと、自動的に開店となります。
            </Typography>
          </div>
          <div
            className={classNames(
              classes.paperContentItem,
              classes.registerStep
            )}
          >
            <div className={classes.registerStepItem}>
              <StepShopOnButton
                onClickAction={() => handleRedirect('/unregistered_shops')}
              />
              <Button
                color="primary"
                onClick={() => {
                  handleRedirect('/unregistered_shops');
                }}
              >
                店舗登録
                <br />
                &nbsp;
              </Button>
            </div>
            <StepArrowLine />
            <div className={classes.registerStepItem}>
              <StepMenuOnButton disabled="true" />
              <Button color="primary" disabled>
                メニュー
                <br />
                登録
              </Button>
            </div>
            <StepArrowLine />
            <div className={classes.registerStepItem}>
              <StepIdentityOnButton disabled="true" />
              <Button color="primary" disabled>
                本人情報
                <br />
                登録
              </Button>
            </div>
            <StepArrowLine />
            <div className={classes.registerStepItemWidth}>
              <StepIdentityConfirmOnButton disabled="true" />
              <Button color="primary" disabled>
                &nbsp;
                <br />
                &nbsp;
              </Button>
            </div>
          </div>
          <div className={classes.paperContentItem}>
            <Link
              href="https://drive.google.com/file/d/1BKfAXptdSVANRoX9DGO-IDu3vDi49CaL"
              target="_blank"
            >
              ごちめし店舗登録マニュアルはこちら
            </Link>
          </div>
          <div>
            <Button
              color="primary"
              onClick={() => {
                handleRedirect('/');
              }}
            >
              ログイン画面はこちら
            </Button>
          </div>
        </div>
      </Paper>
      <PublicFooter />
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
